import Dashboard from "./pages/Dashboard";

const dashboardRoutes = [
  {
    path: "",
    element: <Dashboard />,
  },
];

export default dashboardRoutes;
